angular.module('tgaAdmin').directive('app', [
  function () {
    return {
      restrict: 'E',
      templateUrl: 'templates/views/app.html',
    };
  },
]);
